/**
 * Shared types for user interaction and tool confirmation system
 * Based on gemini-cli core types for consistency
 */
// Tool confirmation outcome enum - matches gemini-cli exactly
export var ToolConfirmationOutcome;
(function (ToolConfirmationOutcome) {
    ToolConfirmationOutcome["ProceedOnce"] = "proceed_once";
    ToolConfirmationOutcome["ProceedAlways"] = "proceed_always";
    ToolConfirmationOutcome["ProceedAlwaysServer"] = "proceed_always_server";
    ToolConfirmationOutcome["ProceedAlwaysTool"] = "proceed_always_tool";
    ToolConfirmationOutcome["ModifyWithEditor"] = "modify_with_editor";
    ToolConfirmationOutcome["Cancel"] = "cancel";
})(ToolConfirmationOutcome || (ToolConfirmationOutcome = {}));
// Streaming and conversation state enums
export var StreamingState;
(function (StreamingState) {
    StreamingState["Idle"] = "idle";
    StreamingState["Responding"] = "responding";
    StreamingState["WaitingForConfirmation"] = "waiting_for_confirmation";
})(StreamingState || (StreamingState = {}));
export var ConversationStatus;
(function (ConversationStatus) {
    ConversationStatus["Active"] = "active";
    ConversationStatus["Paused"] = "paused";
    ConversationStatus["WaitingConfirmation"] = "waiting_confirmation";
    ConversationStatus["Completed"] = "completed";
})(ConversationStatus || (ConversationStatus = {}));
// Tool execution status
export var ToolExecutionStatus;
(function (ToolExecutionStatus) {
    ToolExecutionStatus["Validating"] = "validating";
    ToolExecutionStatus["Scheduled"] = "scheduled";
    ToolExecutionStatus["AwaitingApproval"] = "awaiting_approval";
    ToolExecutionStatus["Executing"] = "executing";
    ToolExecutionStatus["Success"] = "success";
    ToolExecutionStatus["Error"] = "error";
    ToolExecutionStatus["Cancelled"] = "cancelled";
})(ToolExecutionStatus || (ToolExecutionStatus = {}));
// Approval mode settings
export var ApprovalMode;
(function (ApprovalMode) {
    ApprovalMode["Default"] = "default";
    ApprovalMode["AutoEdit"] = "auto_edit";
    ApprovalMode["YOLO"] = "yolo";
})(ApprovalMode || (ApprovalMode = {}));
